module.exports = require("core-js/library/fn/array/find-index");


//////////////////
// WEBPACK FOOTER
// ../~/@babel/runtime-corejs2/core-js/array/find-index.js
// module id = 228
// module chunks = 1